import { lazyRetry } from '@cast/utils';

import { ACCESS_CONTROL_ROUTE_SEGMENTS } from '@oneclick/constants/navigation';

import type { OneClickNavItem } from '@oneclick/routing';
const UsersPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/UsersPage').then(
    (m) => ({ default: m.UsersPage })
  )
);
const UserGroupsPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/UserGroupsPage').then(
    (m) => ({ default: m.UserGroupsPage })
  )
);
const ServiceAccounts = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/ServiceAccounts').then(
    (m) => ({ default: m.ServiceAccounts })
  )
);
const RoleBindingsPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/RoleBindingsPage').then(
    (m) => ({ default: m.RoleBindingsPage })
  )
);
const ResourcesPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/ResourcesPage').then(
    (m) => ({ default: m.ResourcesPage })
  )
);

export const ACCESS_CONTROL_ROUTE_CONFIG: OneClickNavItem[] = [
  {
    id: 'users',
    title: 'Users',
    route: ACCESS_CONTROL_ROUTE_SEGMENTS.users,
    page: UsersPage,
    breadcrumbs: ['Users'],
    rules: [['view', 'OrganizationAccessManagement']],
  },
  {
    id: 'userGroups',
    title: 'User groups',
    route: ACCESS_CONTROL_ROUTE_SEGMENTS.userGroups,
    page: UserGroupsPage,
    breadcrumbs: ['User groups'],
    rules: [['view', 'OrganizationAccessManagement']],
  },
  {
    id: 'serviceAccounts',
    title: 'Service accounts',
    route: ACCESS_CONTROL_ROUTE_SEGMENTS.serviceAccounts,
    page: ServiceAccounts,
    breadcrumbs: ['Service accounts'],
    rules: [['view', 'OrganizationAccessManagement']],
  },
  {
    id: 'roleBindings',
    title: 'Role bindings',
    route: ACCESS_CONTROL_ROUTE_SEGMENTS.roleBindings,
    page: RoleBindingsPage,
    breadcrumbs: ['Role bindings'],
    rules: [
      ['view', 'OrganizationAccessManagement'],
      ['view', 'FeatureOrganizationManagementRoleBindings'],
    ],
  },
  {
    id: 'resources',
    title: 'Resources',
    route: ACCESS_CONTROL_ROUTE_SEGMENTS.resources,
    page: ResourcesPage,
    breadcrumbs: ['Resources'],
    rules: [['view', 'OrganizationAccessManagement']],
  },
];
